import PropTypes from 'prop-types';

import { Typography } from '@mui/material';

import { useTransl } from 'shared/lib/i18n';

import Actions from '../Modal/ActionsComponent';

const InactivityModalComponent = ({
  state: { secondsRemaining },
  props: { onConfirm, onCancel },
}) => {
  const { t } = useTransl();
  const actions = [
    { label: t('actions.stayLoggedIn'), onClick: onConfirm, color: 'primary' },
    {
      label: t('actions.logOut'),
      onClick: onCancel,
      color: 'secondary',
    },
  ];
  return (
    <>
      <Typography variant="body1">
        {t('modal.body.inactivityWarning', { secondsRemaining })}
      </Typography>
      <Actions actions={actions} />
    </>
  );
};

InactivityModalComponent.propTypes = {
  state: PropTypes.shape({
    secondsRemaining: PropTypes.number.isRequired,
  }).isRequired,
  props: PropTypes.shape({
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
  }).isRequired,
};

export default InactivityModalComponent;
